import SbGameCommon from '~/core';
import { DeviceType, FontFamilyType, FontSizeCountdownText, SpriteSheetBannerElementName, TeamType, ThemeColor, TIMER_SCALE_ANIMATE, } from '~/enum';
import { EventItem, TeamWinningValue, TotalBettingAndTotalUserTeamField } from '~/enum/event';
import { calculateTimeDifference, convertNumberToTimeWithFormat, getSpriteLogoClbWithTeamName, hexadecimal, numberFormat, sleep, } from '~/utils/common';
import { Particle } from './Particle';
// import { Rect } from '~/core/shapes/Rect';
class BannerVoltaModel {
    constructor(textureData, spriteImage, textureLogoCLBData, spriteLogoCLBImage) {
        this.textureData = textureData;
        this.spriteImage = spriteImage;
        this.textureLogoCLBData = textureLogoCLBData;
        this.spriteLogoCLBImage = spriteLogoCLBImage;
        this.stageWidth = 0;
        this.stageHeight = 0;
        // Elements
        this.backgroundImage = null;
        this.backgroundImageZIndex1 = null;
        this.inviteStartImage = null;
        this.circleLightImage = null;
        this.circleBlackImage = null;
        this.circleTransparentImage = null;
        this.timerCountdownText = null;
        this.iconCoinsWonHome = null;
        this.iconCoinsWonAway = null;
        this.bgWinningHomeImage = null;
        // private bgCloseHomeRect: Rect | null = null;
        this.bgWinningAwayImage = null;
        // private bgCloseAwayRect: Rect | null = null;
        this.iconCloverHomeImage = null;
        this.iconCloverAwayImage = null;
        this.iconCoinRotateHomeImage = null;
        this.iconCoinRotateAwayImage = null;
        this.iconDiamondBlueHomeImage = null;
        this.iconDiamondBlueAwayImage = null;
        this.iconDiamondSilverHomeImage = null;
        this.iconDiamondSilverAwayImage = null;
        this.iconGiftHomeImage = null;
        this.iconGiftAwayImage = null;
        this.iconMedalHomeImage = null;
        this.iconMedalAwayImage = null;
        this.tweenIconMedalAway = null;
        this.tweenGroupIconsWinAway = null;
        this.tweenIconMedalHome = null;
        this.tweenGroupIconsWinHome = null;
        this.isMobile = true;
        this.sizeLogo = 0;
        this.sizeText = {
            teamName: 0,
            totalAmount: 0,
            userCount: 0,
        };
        this.homeSpriteElementBoxTeam = {
            dx: 0,
            dy: 0,
        };
        this.homeTeamLogo = null;
        this.homeTeamName = null;
        this.homeTotalAmountBetting = null;
        this.homeIconUser = null;
        this.homeTotalUserCount = null;
        this.homeBoxTotalAmountBetting = null;
        this.awaySpriteElementBoxTeam = {
            dx: 0,
            dy: 0,
        };
        this.awayTeamLogo = null;
        this.awayTeamName = null;
        this.awayTotalAmountBetting = null;
        this.awayIconUser = null;
        this.awayTotalUserCount = null;
        this.awayBoxTotalAmountBetting = null;
        this.countdownValue = 60; // Default starting value
        // Animations
        this.animationCircleLight = null;
        this.animationCircleBlack = null;
        this.animationCircleTransparent = null;
        // private animationTimerCountdownText: Animation | null = null;
        this.animationTotalAmountBettingHome = null;
        this.animationTotalAmountBettingAway = null;
        this.animationBallTheme = null;
        this.countdownAnimation = null;
        this.particles = [];
        this.particleAnimation = null;
        this.isParticleAnimating = false;
        this.particleColors = [
            '#FFD700', // Gold
            '#FFC125', // Goldenrod
            '#FFCC33', // Sunglow
            '#F1C40F', // Sunflower
            '#FFB700', // Amber
            '#FFBF00', // Selective Yellow
            '#E6BE8A', // Gold Pale
            '#DAA520', // Goldenrod
            '#FDDA0D', // Yellow Gold
            '#B8860B', // Dark Goldenrod
            '#FEF9E7', // Gold Highlight
            '#FAD7A0', // Gold Light
        ];
        this.themeColor = ThemeColor.Gold;
        this.stage = null; // Initialize as null, will be set later
        this.layer = null; // Initialize as null, will be set later
        this.group = null; // Initialize as null, will be set later
        this.groupIconsWinAway = new SbGameCommon.Group();
        this.groupIconsWinHome = new SbGameCommon.Group();
    }
    // Setup device type and theme color
    setupDeviceAndTheme(device, themeColor) {
        this.themeColor = themeColor;
        this.isMobile = device === DeviceType.Mobile;
    }
    // Setup stage, layer, and group
    setupStageLayerGroup(stage, layer, group) {
        this.stage = stage;
        this.layer = layer;
        this.group = group;
        this.stageWidth = stage.width();
        this.stageHeight = stage.height();
        if (this.isMobile) {
            const sizeGroupIcons = 45;
            this.groupIconsWinAway.setAttrs({
                x: stage.width() - 6 - sizeGroupIcons,
                y: 0,
                width: sizeGroupIcons,
                height: stage.height(),
                visible: false,
            });
            this.groupIconsWinHome.setAttrs({
                x: 6,
                y: 0,
                width: sizeGroupIcons,
                height: stage.height(),
                visible: false,
            });
        }
        else {
            const sizeGroupIcons = 130;
            this.groupIconsWinAway.setAttrs({
                x: stage.width() - 8 - sizeGroupIcons,
                y: 0,
                width: sizeGroupIcons,
                height: stage.height(),
                visible: false,
            });
            this.groupIconsWinHome.setAttrs({
                x: 8,
                y: 0,
                width: sizeGroupIcons,
                height: stage.height(),
                visible: false,
            });
        }
    }
    init() {
        // Background image
        const backgroundTexture = this.textureData[SpriteSheetBannerElementName.Background];
        this.backgroundImage = new SbGameCommon.Image({
            x: 0,
            y: 0,
            image: this.spriteImage,
            width: this.stageWidth,
            height: this.stageHeight,
            crop: {
                x: backgroundTexture.sx,
                y: backgroundTexture.sy,
                width: backgroundTexture.sWidth,
                height: backgroundTexture.sHeight,
            },
        });
        // Background image ZIndex1
        const textureZIndex1Texture = this.textureData[SpriteSheetBannerElementName.BackgroundZIndex1];
        this.backgroundImageZIndex1 = new SbGameCommon.Image({
            x: 0,
            y: 0,
            image: this.spriteImage,
            width: this.stageWidth,
            height: this.stageHeight,
            crop: {
                x: textureZIndex1Texture.sx,
                y: textureZIndex1Texture.sy,
                width: textureZIndex1Texture.sWidth,
                height: textureZIndex1Texture.sHeight,
            },
        });
        // Invite Start image
        const inviteStartTexture = this.textureData[SpriteSheetBannerElementName.InviteStar];
        const dWidthInviteStar = Math.round(this.stageWidth / 2.3);
        const gapInviteStar = 4; // Gap between the top of the stage and the invite star
        const dHeightInviteStar = this.stageHeight + gapInviteStar;
        const dxInviteStar = Math.round(this.stageWidth / 2 - dWidthInviteStar / 2);
        const dyInviteStar = Math.round(this.stageHeight / 2 - dHeightInviteStar / 2) - gapInviteStar;
        this.inviteStartImage = new SbGameCommon.Image({
            x: dxInviteStar,
            y: dyInviteStar,
            image: this.spriteImage,
            width: dWidthInviteStar,
            height: dHeightInviteStar,
            globalCompositeOperation: 'screen',
            crop: {
                x: inviteStartTexture.sx + 0.5,
                y: inviteStartTexture.sy,
                width: inviteStartTexture.sWidth,
                height: inviteStartTexture.sHeight,
            },
        });
        // Circle Light image
        const circleLightTexture = this.textureData[SpriteSheetBannerElementName.CircleLight];
        const dWidthCircleLight = circleLightTexture.dWidth;
        const dHeightCircleLight = circleLightTexture.dHeight;
        const dxCircleLight = Math.round(this.stageWidth / 2 - dWidthCircleLight / 2);
        const dyCircleLight = Math.round(this.stageHeight / 2 - dHeightCircleLight / 2);
        this.circleLightImage = new SbGameCommon.Image({
            x: dxCircleLight,
            y: dyCircleLight,
            image: this.spriteImage,
            width: dWidthCircleLight,
            height: dHeightCircleLight,
            crop: {
                x: circleLightTexture.sx,
                y: circleLightTexture.sy,
                width: circleLightTexture.sWidth,
                height: circleLightTexture.sHeight,
            },
        });
        // Circle Black image
        const circleBlackTexture = this.textureData[SpriteSheetBannerElementName.CircleBlack];
        const dWidthCircleBlack = circleBlackTexture.dWidth;
        const dHeightCircleBlack = circleBlackTexture.dHeight;
        const dxCircleBlack = Math.round(this.stageWidth / 2 - dWidthCircleBlack / 2);
        const dyCircleBlack = Math.round(this.stageHeight / 2 - dHeightCircleBlack / 2);
        this.circleBlackImage = new SbGameCommon.Image({
            x: dxCircleBlack,
            y: dyCircleBlack,
            image: this.spriteImage,
            width: dWidthCircleBlack,
            height: dHeightCircleBlack,
            crop: {
                x: circleBlackTexture.sx,
                y: circleBlackTexture.sy,
                width: circleBlackTexture.sWidth,
                height: circleBlackTexture.sHeight,
            },
        });
        // Circle Transparent image
        const circleTransparentTexture = this.textureData[SpriteSheetBannerElementName.CircleTransparent];
        const dWidthCircleTransparent = circleTransparentTexture.dWidth;
        const dHeightCircleTransparent = circleTransparentTexture.dHeight;
        const dxCircleTransparent = Math.round(this.stageWidth / 2 - dWidthCircleTransparent / 2);
        const dyCircleTransparent = Math.round(this.stageHeight / 2 - dHeightCircleTransparent / 2);
        this.circleTransparentImage = new SbGameCommon.Image({
            x: dxCircleTransparent,
            y: dyCircleTransparent,
            image: this.spriteImage,
            width: dWidthCircleTransparent,
            height: dHeightCircleTransparent,
            globalCompositeOperation: 'lighter',
            crop: {
                x: circleTransparentTexture.sx,
                y: circleTransparentTexture.sy,
                width: circleTransparentTexture.sWidth,
                height: circleTransparentTexture.sHeight,
            },
        });
        // Timer countdown
        const dxTimerCountdown = Math.round(dxCircleBlack + dWidthCircleBlack / 2);
        const dyTimerCountdown = Math.round(dyCircleBlack + dHeightCircleBlack / 2);
        this.timerCountdownText = new SbGameCommon.Text({
            x: dxTimerCountdown,
            y: dyTimerCountdown,
            text: '00',
            fontSize: this.isMobile
                ? FontSizeCountdownText.Under1Minute
                : FontSizeCountdownText.Under1MinuteDesktop,
            fontFamily: FontFamilyType.BOLD,
            fill: 'white',
            shadowOffsetX: 0,
            shadowOffsetY: 2,
            shadowBlur: 8,
            shadowColor: hexadecimal('#FFFFFF')(50),
        });
        this.timerCountdownText.offset({
            x: Math.floor(this.timerCountdownText.width() / 2),
            y: Math.floor(this.timerCountdownText.height() / 2),
        });
        // Icon Coins Won Away
        // const iconCoinsWonTexture = this.textureData[SpriteSheetBannerElementName.IconCoinsWon];
        // const dWidthIconCoinsWon = Math.round(this.stageHeight * 1.1);
        // const dHeightIconCoinsWon = this.stageHeight;
        // const dxIconCoinsWon = Math.round(this.stage.x() + this.stageWidth - dWidthIconCoinsWon);
        // const dyIconCoinsWon = this.stage.y();
        // this.iconCoinsWonAway = new SbGameCommon.Image({
        //   x: dxIconCoinsWon,
        //   y: dyIconCoinsWon,
        //   image: this.spriteImage,
        //   width: dWidthIconCoinsWon,
        //   height: dHeightIconCoinsWon,
        //   crop: {
        //     x: iconCoinsWonTexture.sx,
        //     y: iconCoinsWonTexture.sy,
        //     width: iconCoinsWonTexture.sWidth,
        //     height: iconCoinsWonTexture.sHeight,
        //   },
        // });
        // // Icon Coins Won Home
        // const dxIconCoinsWonHome = Math.round(0);
        // this.iconCoinsWonHome = new SbGameCommon.Image({
        //   x: dxIconCoinsWonHome,
        //   y: dyIconCoinsWon,
        //   image: this.spriteImage,
        //   width: dWidthIconCoinsWon,
        //   height: dHeightIconCoinsWon,
        //   crop: {
        //     x: iconCoinsWonTexture.sx,
        //     y: iconCoinsWonTexture.sy,
        //     width: iconCoinsWonTexture.sWidth,
        //     height: iconCoinsWonTexture.sHeight,
        //   },
        // });
        // this.iconCoinsWonHome.scaleX(-1);
        // this.iconCoinsWonHome.x(this.iconCoinsWonHome.width());
        // Winning background image
        const bgWinningTexture = this.textureData[SpriteSheetBannerElementName.BgWinning];
        const dWidthBgWinning = Math.round(this.stageWidth / 2 + dWidthCircleBlack);
        const dxWinningAway = Math.round(this.stage.x() + this.stageWidth - dWidthBgWinning);
        this.bgWinningAwayImage = new SbGameCommon.Image({
            x: dxWinningAway,
            y: 0,
            image: this.spriteImage,
            visible: false,
            width: dWidthBgWinning,
            height: bgWinningTexture.dHeight,
            crop: {
                x: bgWinningTexture.sx,
                y: bgWinningTexture.sy,
                width: bgWinningTexture.sWidth,
                height: bgWinningTexture.sHeight,
            },
        });
        // this.bgCloseAwayRect = new SbGameCommon.Rect({
        //   x: dxWinningAway,
        //   y: 0,
        //   width: dWidthBgWinning,
        //   height: bgWinningTexture.dHeight,
        //   fill: hexadecimal('#000000')(80),
        //   visible: false,
        // });
        this.bgWinningHomeImage = new SbGameCommon.Image({
            x: dWidthBgWinning,
            y: 0,
            image: this.spriteImage,
            visible: false,
            opacity: 0.8,
            width: dWidthBgWinning,
            height: bgWinningTexture.sHeight,
            scaleX: -1,
            crop: {
                x: bgWinningTexture.sx,
                y: bgWinningTexture.sy,
                width: bgWinningTexture.sWidth,
                height: bgWinningTexture.sHeight,
            },
        });
        // this.bgCloseHomeRect = new SbGameCommon.Rect({
        //   x: 0,
        //   y: 0,
        //   width: dWidthBgWinning,
        //   height: bgWinningTexture.dHeight,
        //   fill: hexadecimal('#000000')(80),
        //   visible: false,
        // });
        const iconMedalTexture = this.textureData[SpriteSheetBannerElementName.IconMedal];
        this.iconMedalAwayImage = new SbGameCommon.Image({
            x: 0,
            y: 0,
            image: this.spriteImage,
            width: iconMedalTexture.dWidth,
            height: iconMedalTexture.dHeight,
            visible: false,
            crop: {
                x: iconMedalTexture.sx,
                y: iconMedalTexture.sy,
                width: iconMedalTexture.sWidth,
                height: iconMedalTexture.sHeight,
            },
        });
        this.iconMedalHomeImage = new SbGameCommon.Image({
            x: this.stageWidth - iconMedalTexture.dWidth,
            y: 0,
            image: this.spriteImage,
            width: iconMedalTexture.dWidth,
            height: iconMedalTexture.dHeight,
            visible: false,
            crop: {
                x: iconMedalTexture.sx,
                y: iconMedalTexture.sy,
                width: iconMedalTexture.sWidth,
                height: iconMedalTexture.sHeight,
            },
        });
        this.iconMedalHomeImage = new SbGameCommon.Image({
            x: this.stageWidth - iconMedalTexture.dWidth,
            y: 0,
            image: this.spriteImage,
            width: iconMedalTexture.dWidth,
            height: iconMedalTexture.dHeight,
            visible: false,
            crop: {
                x: iconMedalTexture.sx,
                y: iconMedalTexture.sy,
                width: iconMedalTexture.sWidth,
                height: iconMedalTexture.sHeight,
            },
        });
        const iconDiamondBlueTexture = this.textureData[SpriteSheetBannerElementName.IconDiamondBlue];
        const dxIconDiamondBlue = this.isMobile ? -2 : -4;
        this.iconDiamondBlueAwayImage = new SbGameCommon.Image({
            x: dxIconDiamondBlue,
            y: 4,
            image: this.spriteImage,
            width: iconDiamondBlueTexture.dWidth,
            height: iconDiamondBlueTexture.dHeight,
            crop: {
                x: iconDiamondBlueTexture.sx,
                y: iconDiamondBlueTexture.sy,
                width: iconDiamondBlueTexture.sWidth,
                height: iconDiamondBlueTexture.sHeight,
            },
        });
        const gapIconDiamondBlueHome = this.isMobile ? 5 : 0;
        this.iconDiamondBlueHomeImage = new SbGameCommon.Image({
            x: this.groupIconsWinHome.width() - iconDiamondBlueTexture.dWidth + gapIconDiamondBlueHome,
            y: 4,
            image: this.spriteImage,
            width: iconDiamondBlueTexture.dWidth,
            height: iconDiamondBlueTexture.dHeight,
            crop: {
                x: iconDiamondBlueTexture.sx,
                y: iconDiamondBlueTexture.sy,
                width: iconDiamondBlueTexture.sWidth,
                height: iconDiamondBlueTexture.sHeight,
            },
        });
        const iconGiftAwayTexture = this.textureData[SpriteSheetBannerElementName.IconGift];
        const dyIconGiftAway = this.isMobile ? 36 : 86;
        this.iconGiftAwayImage = new SbGameCommon.Image({
            x: 0,
            y: dyIconGiftAway,
            image: this.spriteImage,
            width: iconGiftAwayTexture.dWidth,
            height: iconGiftAwayTexture.dHeight,
            crop: {
                x: iconGiftAwayTexture.sx,
                y: iconGiftAwayTexture.sy,
                width: iconGiftAwayTexture.sWidth,
                height: iconGiftAwayTexture.sHeight,
            },
        });
        this.iconGiftHomeImage = new SbGameCommon.Image({
            x: this.groupIconsWinHome.width() - iconGiftAwayTexture.dWidth,
            y: dyIconGiftAway,
            image: this.spriteImage,
            width: iconGiftAwayTexture.dWidth,
            height: iconGiftAwayTexture.dHeight,
            crop: {
                x: iconGiftAwayTexture.sx,
                y: iconGiftAwayTexture.sy,
                width: iconGiftAwayTexture.sWidth,
                height: iconGiftAwayTexture.sHeight,
            },
        });
        const iconCloverAwayTexture = this.textureData[SpriteSheetBannerElementName.IconClover];
        const gapIconClover = this.isMobile ? 42 : 100;
        this.iconCloverAwayImage = new SbGameCommon.Image({
            x: gapIconClover - iconCloverAwayTexture.dWidth,
            y: 2,
            image: this.spriteImage,
            width: iconCloverAwayTexture.dWidth,
            height: iconCloverAwayTexture.dHeight,
            crop: {
                x: iconCloverAwayTexture.sx,
                y: iconCloverAwayTexture.sy,
                width: iconCloverAwayTexture.sWidth,
                height: iconCloverAwayTexture.sHeight,
            },
        });
        const dxIconCloverHome = this.isMobile ? 2 : 12;
        this.iconCloverHomeImage = new SbGameCommon.Image({
            x: dxIconCloverHome,
            y: 2,
            image: this.spriteImage,
            width: iconCloverAwayTexture.dWidth,
            height: iconCloverAwayTexture.dHeight,
            crop: {
                x: iconCloverAwayTexture.sx,
                y: iconCloverAwayTexture.sy,
                width: iconCloverAwayTexture.sWidth,
                height: iconCloverAwayTexture.sHeight,
            },
        });
        const iconCoinRotateAwayTexture = this.textureData[SpriteSheetBannerElementName.IconCoinRotate];
        const gapIconCoinRotate = this.isMobile ? 42 : 126;
        const dyIconCoinRotate = this.isMobile ? 36 : 85;
        this.iconCoinRotateAwayImage = new SbGameCommon.Image({
            x: gapIconCoinRotate - iconCoinRotateAwayTexture.dWidth,
            y: dyIconCoinRotate,
            image: this.spriteImage,
            width: iconCoinRotateAwayTexture.dWidth,
            height: iconCoinRotateAwayTexture.dHeight,
            crop: {
                x: iconCoinRotateAwayTexture.sx,
                y: iconCoinRotateAwayTexture.sy,
                width: iconCoinRotateAwayTexture.sWidth,
                height: iconCoinRotateAwayTexture.sHeight,
            },
        });
        const dxIconCoinRotateHome = this.isMobile ? 3 : 8;
        this.iconCoinRotateHomeImage = new SbGameCommon.Image({
            x: dxIconCoinRotateHome,
            y: dyIconCoinRotate,
            image: this.spriteImage,
            width: iconCoinRotateAwayTexture.dWidth,
            height: iconCoinRotateAwayTexture.dHeight,
            crop: {
                x: iconCoinRotateAwayTexture.sx,
                y: iconCoinRotateAwayTexture.sy,
                width: iconCoinRotateAwayTexture.sWidth,
                height: iconCoinRotateAwayTexture.sHeight,
            },
        });
        const iconDiamondSilverAwayTexture = this.textureData[SpriteSheetBannerElementName.IconDiamondSilver];
        const gapIconDiamondSilver = this.isMobile ? 45 : 120;
        const dyIconDiamondSilver = this.isMobile ? 24 : 55;
        this.iconDiamondSilverAwayImage = new SbGameCommon.Image({
            x: gapIconDiamondSilver - iconDiamondSilverAwayTexture.dWidth,
            y: dyIconDiamondSilver,
            image: this.spriteImage,
            width: iconDiamondSilverAwayTexture.dWidth,
            height: iconDiamondSilverAwayTexture.dHeight,
            crop: {
                x: iconDiamondSilverAwayTexture.sx,
                y: iconDiamondSilverAwayTexture.sy,
                width: iconDiamondSilverAwayTexture.sWidth,
                height: iconDiamondSilverAwayTexture.sHeight,
            },
        });
        const dxIconDiamondSilver = this.isMobile ? 3 : 6;
        this.iconDiamondSilverHomeImage = new SbGameCommon.Image({
            x: dxIconDiamondSilver,
            y: dyIconDiamondSilver,
            image: this.spriteImage,
            width: iconDiamondSilverAwayTexture.dWidth,
            height: iconDiamondSilverAwayTexture.dHeight,
            crop: {
                x: iconDiamondSilverAwayTexture.sx,
                y: iconDiamondSilverAwayTexture.sy,
                width: iconDiamondSilverAwayTexture.sWidth,
                height: iconDiamondSilverAwayTexture.sHeight,
            },
        });
        // Team
        if (this.isMobile) {
            this.sizeLogo = 30;
            this.homeSpriteElementBoxTeam = {
                dx: Math.round(this.stage.x() + 16),
                dy: Math.round(this.stage.y() + 8),
            };
            this.awaySpriteElementBoxTeam = {
                dx: Math.round(this.stage.x() + this.stageWidth - 16 - this.sizeLogo),
                dy: Math.round(this.stage.y() + 8),
            };
            this.sizeText = {
                teamName: 10,
                totalAmount: 12,
                userCount: 10,
            };
        }
        else {
            this.sizeLogo = 90;
            this.homeSpriteElementBoxTeam = {
                dx: Math.round(this.stage.x() + 32),
                dy: Math.round(this.stage.y() + this.stageHeight / 2 - this.sizeLogo / 2),
            };
            this.awaySpriteElementBoxTeam = {
                dx: Math.round(this.stage.x() + this.stageWidth - 40 - this.sizeLogo),
                dy: Math.round(this.stage.y() + this.stageHeight / 2 - this.sizeLogo / 2),
            };
            this.sizeText = {
                teamName: 24,
                totalAmount: 32,
                userCount: 20,
            };
        }
        const dxIconBall = dxCircleBlack;
        const dyIconBal = dyCircleBlack;
        const dWidthIconBall = dWidthCircleBlack;
        const dHeightIconBall = dHeightCircleBlack;
        let ballThemeStep1Texture;
        let ballThemeStep2Texture;
        switch (this.themeColor) {
            case ThemeColor.Gold: {
                ballThemeStep1Texture = this.textureData[SpriteSheetBannerElementName.IconBall1Step1];
                ballThemeStep2Texture = this.textureData[SpriteSheetBannerElementName.IconBall1Step2];
                break;
            }
            case ThemeColor.Green: {
                ballThemeStep1Texture = this.textureData[SpriteSheetBannerElementName.IconBall2Step1];
                ballThemeStep2Texture = this.textureData[SpriteSheetBannerElementName.IconBall2Step2];
                break;
            }
            case ThemeColor.Red: {
                ballThemeStep1Texture = this.textureData[SpriteSheetBannerElementName.IconBall3Step1];
                ballThemeStep2Texture = this.textureData[SpriteSheetBannerElementName.IconBall3Step2];
                break;
            }
            case ThemeColor.LightGreen: {
                ballThemeStep1Texture = this.textureData[SpriteSheetBannerElementName.IconBall4Step1];
                ballThemeStep2Texture = this.textureData[SpriteSheetBannerElementName.IconBall4Step2];
                break;
            }
            case ThemeColor.Blue: {
                ballThemeStep1Texture = this.textureData[SpriteSheetBannerElementName.IconBall5Step1];
                ballThemeStep2Texture = this.textureData[SpriteSheetBannerElementName.IconBall5Step2];
                break;
            }
            default: {
                ballThemeStep1Texture = this.textureData[SpriteSheetBannerElementName.IconBall1Step1];
                ballThemeStep2Texture = this.textureData[SpriteSheetBannerElementName.IconBall1Step2];
                break;
            }
        }
        const animationsBallTheme = [
            ballThemeStep1Texture.sx,
            ballThemeStep1Texture.sy,
            ballThemeStep1Texture.sWidth,
            ballThemeStep1Texture.sHeight,
            ballThemeStep2Texture.sx,
            ballThemeStep2Texture.sy,
            ballThemeStep2Texture.sWidth,
            ballThemeStep2Texture.sHeight,
        ];
        // Animation for Circle Light
        this.animationCircleLight = this.setupAnimationImageScale(this.circleLightImage, 1.0, 1.1);
        this.animationCircleBlack = this.setupAnimationImageScale(this.circleBlackImage, 1.0, 1.1);
        this.animationCircleTransparent = this.setupAnimationImageScale(this.circleTransparentImage, 1.0, 1.1);
        this.animationBallTheme = this.createAnimationBallThemeSprite({
            animations: animationsBallTheme,
            dx: dxIconBall,
            dy: dyIconBal,
            dWidth: dWidthIconBall,
            dHeight: dHeightIconBall,
        });
    }
    // --- Start getters for each element, throwing an error if not initialized ---
    _getBackgroundImage() {
        if (!this.backgroundImage) {
            throw new Error('Background image is not initialized. Call init() first.');
        }
        return this.backgroundImage;
    }
    _getBackgroundImageZIndex1() {
        if (!this.backgroundImageZIndex1) {
            throw new Error('Background image ZIndex1 is not initialized. Call init() first.');
        }
        return this.backgroundImageZIndex1;
    }
    _getInviteStartBackground() {
        if (!this.inviteStartImage) {
            throw new Error('Background image Invite Start is not initialized. Call init() first.');
        }
        return this.inviteStartImage;
    }
    _getCircleLightImage() {
        if (!this.circleLightImage) {
            throw new Error('Circle Light image is not initialized. Call init() first.');
        }
        return this.circleLightImage;
    }
    _getCircleBlackImage() {
        if (!this.circleBlackImage) {
            throw new Error('Circle Black image is not initialized. Call init() first.');
        }
        return this.circleBlackImage;
    }
    _getCircleTransparentImage() {
        if (!this.circleTransparentImage) {
            throw new Error('Circle Transparent image is not initialized. Call init() first.');
        }
        return this.circleTransparentImage;
    }
    _getTimerCountdownText() {
        if (!this.timerCountdownText) {
            throw new Error('Timer countdown text is not initialized. Call init() first.');
        }
        return this.timerCountdownText;
    }
    _getHomeTeamLogo() {
        if (!this.homeTeamLogo) {
            throw new Error('Home team logo is not initialized. Call init() first.');
        }
        return this.homeTeamLogo;
    }
    _getAwayTeamLogo() {
        if (!this.awayTeamLogo) {
            throw new Error('Away team logo is not initialized. Call init() first.');
        }
        return this.awayTeamLogo;
    }
    _getHomeTeamName() {
        if (!this.homeTeamName) {
            throw new Error('Home team name is not initialized. Call init() first.');
        }
        return this.homeTeamName;
    }
    _getAwayTeamName() {
        if (!this.awayTeamName) {
            throw new Error('Away team name is not initialized. Call init() first.');
        }
        return this.awayTeamName;
    }
    _getHomeTotalAmountBetting() {
        if (!this.homeTotalAmountBetting) {
            throw new Error('Home total amount betting is not initialized. Call init() first.');
        }
        return this.homeTotalAmountBetting;
    }
    _getAwayTotalAmountBetting() {
        if (!this.awayTotalAmountBetting) {
            throw new Error('Away total amount betting is not initialized. Call init() first.');
        }
        return this.awayTotalAmountBetting;
    }
    _getHomeIconUser() {
        if (!this.homeIconUser) {
            throw new Error('Home icon user is not initialized. Call init() first.');
        }
        return this.homeIconUser;
    }
    _getAwayIconUser() {
        if (!this.awayIconUser) {
            throw new Error('Away icon user is not initialized. Call init() first.');
        }
        return this.awayIconUser;
    }
    _getHomeTotalUserCount() {
        if (!this.homeTotalUserCount) {
            throw new Error('Home total user count is not initialized. Call init() first.');
        }
        return this.homeTotalUserCount;
    }
    _getAwayTotalUserCount() {
        if (!this.awayTotalUserCount) {
            throw new Error('Away total user count is not initialized. Call init() first.');
        }
        return this.awayTotalUserCount;
    }
    _getIconCoinsWonHome() {
        if (!this.iconCoinsWonHome) {
            throw new Error('Icon Coins Won Home is not initialized. Call init() first.');
        }
        return this.iconCoinsWonHome;
    }
    _getIconCoinsWonAway() {
        if (!this.iconCoinsWonAway) {
            throw new Error('Icon Coins Won Away is not initialized. Call init() first.');
        }
        return this.iconCoinsWonAway;
    }
    // --- End Getters ---
    // --- Start draw methods for each element ---
    drawBackground() {
        this.group.add(this.backgroundImage);
    }
    drawBackgroundZIndex1() {
        this.group.add(this.backgroundImageZIndex1);
    }
    drawInviteStart() {
        this.group.add(this.inviteStartImage);
    }
    drawCircleLight() {
        this.group.add(this.circleLightImage);
    }
    drawCircleBlack() {
        this.group.add(this.circleBlackImage);
    }
    drawCircleTransparent() {
        this.group.add(this.circleTransparentImage);
    }
    updateFontSizeTimerCountdown(time) {
        if (this.timerCountdownText) {
            const fontSize = this.timerCountdownText.fontSize();
            if (this.isMobile) {
                if (time > 60 && fontSize === FontSizeCountdownText.Under1Minute) {
                    this.timerCountdownText.fontSize(FontSizeCountdownText.Over1Minute);
                }
                else if (time <= 60 && fontSize === FontSizeCountdownText.Over1Minute) {
                    this.timerCountdownText.fontSize(FontSizeCountdownText.Under1Minute);
                }
            }
            else {
                if (time > 60 && fontSize === FontSizeCountdownText.Under1MinuteDesktop) {
                    this.timerCountdownText.fontSize(FontSizeCountdownText.Over1MinuteDesktop);
                }
                else if (time <= 60 && fontSize === FontSizeCountdownText.Over1MinuteDesktop) {
                    this.timerCountdownText.fontSize(FontSizeCountdownText.Under1MinuteDesktop);
                }
            }
        }
    }
    drawTimerCountdownText() {
        if (this.timerCountdownText) {
            this.updateFontSizeTimerCountdown(this.countdownValue);
            this.timerCountdownText.text(convertNumberToTimeWithFormat(this.countdownValue));
            this.timerCountdownText.offset({
                x: Math.floor(this.timerCountdownText.width() / 2),
                y: Math.floor(this.timerCountdownText.height() / 2),
            });
            this.group.add(this.timerCountdownText);
        }
    }
    removeWhenDrawElement(shape) {
        if (!shape)
            return;
        shape.remove();
    }
    genLogoImage(teamType, teamName) {
        if (teamType === TeamType.HOME) {
            this.removeWhenDrawElement(this.homeTeamLogo);
        }
        else {
            this.removeWhenDrawElement(this.awayTeamLogo);
        }
        let logoTexture = getSpriteLogoClbWithTeamName(this.textureLogoCLBData, teamName, teamType === TeamType.HOME);
        const dWidthLogo = this.sizeLogo;
        const dHeightLogo = this.sizeLogo;
        let dxLogo = 0;
        let dyLogo = 0;
        switch (teamType) {
            case TeamType.HOME: {
                dxLogo = this.homeSpriteElementBoxTeam.dx;
                dyLogo = this.homeSpriteElementBoxTeam.dy;
                if (!logoTexture) {
                    logoTexture = this.textureLogoCLBData['home-default'];
                }
                break;
            }
            case TeamType.AWAY: {
                dxLogo = this.awaySpriteElementBoxTeam.dx;
                dyLogo = this.awaySpriteElementBoxTeam.dy;
                if (!logoTexture) {
                    logoTexture = this.textureLogoCLBData['away-default'];
                }
                break;
            }
            default: {
                throw new Error(`Unknown team type: ${teamType}`);
            }
        }
        const logoImage = new SbGameCommon.Image({
            x: dxLogo,
            y: dyLogo,
            image: this.spriteLogoCLBImage,
            width: dWidthLogo,
            height: dHeightLogo,
            crop: {
                x: logoTexture.sx,
                y: logoTexture.sy,
                width: logoTexture.sWidth,
                height: logoTexture.sHeight,
            },
        });
        if (teamType === TeamType.HOME) {
            this.homeTeamLogo = logoImage;
        }
        else {
            this.awayTeamLogo = logoImage;
        }
        this.group.add(logoImage);
    }
    drawTextTeamName(teamType, teamName) {
        var _a, _b;
        if (teamType === TeamType.HOME) {
            this.removeWhenDrawElement(this.homeTeamName);
        }
        else {
            this.removeWhenDrawElement(this.awayTeamName);
        }
        let dxTextTeamName = 0;
        let dyTextTeamName = 0;
        const gapDx = this.isMobile ? 8 : 16;
        const gapDy = this.isMobile ? 4 : 8; // Adjust gap for mobile and desktop
        if (teamType === TeamType.HOME) {
            dxTextTeamName = Math.round(this.homeTeamLogo.x() + this.homeTeamLogo.width() + gapDx);
            dyTextTeamName = Math.round(this.homeTeamLogo.y() + gapDy);
        }
        else {
            dxTextTeamName = Math.round(this.awayTeamLogo.x() - gapDx);
            dyTextTeamName = Math.round(this.awayTeamLogo.y() + gapDy);
        }
        const textTeamName = new SbGameCommon.Text({
            x: dxTextTeamName,
            y: dyTextTeamName,
            text: teamName,
            fontSize: this.sizeText.teamName,
            fontFamily: FontFamilyType.MEDIUM,
            fill: '#FFDCA6',
        });
        if (teamType === TeamType.HOME) {
            this.homeTeamName = textTeamName;
            (_a = this.iconMedalHomeImage) === null || _a === void 0 ? void 0 : _a.setAttrs({
                x: dxTextTeamName + textTeamName.width() + 4,
                y: dyTextTeamName + textTeamName.height() / 2 - this.iconMedalHomeImage.height() / 2 - 3,
            });
        }
        else {
            this.awayTeamName = textTeamName;
            textTeamName.offsetX(textTeamName.width());
            (_b = this.iconMedalAwayImage) === null || _b === void 0 ? void 0 : _b.setAttrs({
                x: dxTextTeamName - this.iconMedalAwayImage.width() - 4,
                y: dyTextTeamName + textTeamName.height() / 2 - this.iconMedalAwayImage.height() / 2 - 3,
                offsetX: textTeamName.width(),
            });
        }
        this.group.add(textTeamName);
    }
    // Add this method before or after your drawing methods
    applyTextStyles(textObject, options) {
        const { fillColor, fillGradient, strokeColor, strokeGradient, strokeWidth } = options;
        // Apply solid fill color
        if (fillColor) {
            textObject.fill(fillColor);
        }
        // Apply fill gradient if provided
        if (fillGradient && fillGradient.colors.length === fillGradient.stops.length) {
            const gradient = this.layer.getContext().createLinearGradient(0, 0, textObject.width(), 0);
            fillGradient.colors.forEach((color, index) => {
                gradient.addColorStop(fillGradient.stops[index], color);
            });
            textObject.fill(gradient);
        }
        // Apply stroke width if provided
        if (strokeWidth !== undefined) {
            textObject.strokeWidth(strokeWidth);
        }
        // Apply solid stroke color
        if (strokeColor) {
            textObject.stroke(strokeColor);
        }
        // Apply stroke gradient if provided
        if (strokeGradient && strokeGradient.colors.length === strokeGradient.stops.length) {
            const gradient = this.layer.getContext().createLinearGradient(0, 0, textObject.width(), 0);
            strokeGradient.colors.forEach((color, index) => {
                gradient.addColorStop(strokeGradient.stops[index], color);
            });
            textObject.stroke(gradient);
        }
        return textObject;
    }
    drawBoxTotalAmountBetting(teamType) {
        const isHome = teamType === TeamType.HOME;
        this.removeWhenDrawElement(isHome ? this.homeBoxTotalAmountBetting : this.awayBoxTotalAmountBetting);
        const dxBox = isHome ? 0 : this.backgroundImage.width();
        let dyBox = 0;
        if (this.isMobile) {
            dyBox = Math.round(this.homeTeamName.y() + this.homeTeamName.height());
        }
        else {
            dyBox = Math.round(this.homeTeamName.y() + this.homeTeamName.height() + 8);
        }
        const boxTexture = this.textureData[SpriteSheetBannerElementName.BoxStakeAmount];
        const dWidthBox = boxTexture.dWidth;
        const dHeightBox = boxTexture.dHeight;
        const boxImage = new SbGameCommon.Image({
            x: dxBox,
            y: dyBox,
            image: this.spriteImage,
            width: dWidthBox,
            height: dHeightBox,
            crop: {
                x: boxTexture.sx,
                y: boxTexture.sy,
                width: boxTexture.sWidth,
                height: boxTexture.sHeight,
            },
        });
        if (!isHome) {
            boxImage.offsetX(boxImage.width());
            this.awayBoxTotalAmountBetting = boxImage;
        }
        else {
            this.homeBoxTotalAmountBetting = boxImage;
        }
        this.group.add(boxImage);
    }
    drawTextTotalAmountBetting(teamType, totalAmount) {
        const isHome = teamType === TeamType.HOME;
        this.removeWhenDrawElement(isHome ? this.homeTotalAmountBetting : this.awayTotalAmountBetting);
        const gap = this.isMobile ? 4 : 18; // Gap between team name and total amount text
        let dxTextTotalAmount = 0;
        const dyTextTotalAmount = Math.round(this.homeTeamName.y() + this.homeTeamName.height() + gap);
        const text = isHome ? `$${numberFormat(totalAmount)}` : `${numberFormat(totalAmount)}$`;
        if (isHome) {
            dxTextTotalAmount = Math.round(this.homeTeamName.x());
        }
        else {
            dxTextTotalAmount = Math.round(this.awayTeamName.x());
        }
        const textTotalAmount = new SbGameCommon.Text({
            x: dxTextTotalAmount,
            y: dyTextTotalAmount,
            text,
            fontSize: this.sizeText.totalAmount,
            fontFamily: FontFamilyType.MEDIUM,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowBlur: 25,
            shadowColor: hexadecimal('#FFB300')(100),
        });
        this.applyTextStyles(textTotalAmount, {
            fillColor: '#FFFFFF',
            fillGradient: {
                colors: ['#FFFFFF', '#FFD47A', '#FFF9F1'],
                stops: [0, 0.5, 1],
            },
            strokeWidth: 1,
            strokeColor: hexadecimal('#FFB300')(50),
        });
        if (isHome) {
            this.homeTotalAmountBetting = textTotalAmount;
        }
        else {
            textTotalAmount.offsetX(textTotalAmount.width() || 0);
            this.awayTotalAmountBetting = textTotalAmount;
        }
        this.group.add(textTotalAmount);
    }
    drawUserIconTeam(teamType) {
        var _a;
        const isHome = teamType === TeamType.HOME;
        this.removeWhenDrawElement(isHome ? this.homeIconUser : this.awayIconUser);
        let dxIconUser = 0;
        let dyIconUser = 0;
        const iconUserTexture = this.textureData[isHome
            ? SpriteSheetBannerElementName.IconUserHome
            : SpriteSheetBannerElementName.IconUserAway];
        const dWidthIconUser = iconUserTexture.dWidth;
        const dHeightIconUser = iconUserTexture.dHeight;
        if (this.isMobile) {
            dxIconUser = isHome ? this.homeTeamName.x() : this.awayTeamName.x();
            dyIconUser = Math.round(this.homeTotalAmountBetting.y() + this.homeTotalAmountBetting.getHeight() + 4);
        }
        else {
            dxIconUser = isHome
                ? this.circleLightImage.x() - this.circleLightImage.width() * 0.85
                : this.circleLightImage.x() + this.circleLightImage.width() * 0.85;
            dyIconUser = Math.round(this.homeBoxTotalAmountBetting.y() +
                ((_a = this.homeBoxTotalAmountBetting) === null || _a === void 0 ? void 0 : _a.getHeight()) / 2 -
                dyIconUser / 2 -
                10);
        }
        const iconUserImage = new SbGameCommon.Image({
            x: dxIconUser,
            y: dyIconUser,
            image: this.spriteImage,
            width: dWidthIconUser,
            height: dHeightIconUser,
            crop: {
                x: iconUserTexture.sx,
                y: iconUserTexture.sy,
                width: iconUserTexture.sWidth,
                height: iconUserTexture.sHeight,
            },
        });
        if (isHome) {
            this.homeIconUser = iconUserImage;
        }
        else {
            this.awayIconUser = iconUserImage;
            iconUserImage.offsetX(iconUserImage.width());
        }
        this.group.add(iconUserImage);
    }
    drawTotalUserCount(teamType, totalUserCount) {
        const isHome = teamType === TeamType.HOME;
        this.removeWhenDrawElement(isHome ? this.homeTotalUserCount : this.awayTotalUserCount);
        let dxTextTotalUserCount = 0;
        let dyTextTotalUserCount = 0;
        if (this.isMobile) {
            dxTextTotalUserCount = isHome
                ? Math.round(this.homeIconUser.x() + this.homeIconUser.width())
                : Math.round(this.awayIconUser.x());
            dyTextTotalUserCount = Math.round(this.homeIconUser.y() + this.homeIconUser.height() / 2 - 4);
        }
        else {
            dxTextTotalUserCount = isHome
                ? Math.round(this.homeIconUser.x()) - 4
                : Math.round(this.awayIconUser.x()) + 4;
            dyTextTotalUserCount = Math.round(this.homeIconUser.y() + 4);
        }
        const text = totalUserCount.toString();
        const textTotalUserCount = new SbGameCommon.Text({
            x: dxTextTotalUserCount,
            y: dyTextTotalUserCount,
            text,
            fontSize: this.sizeText.userCount,
            fontFamily: FontFamilyType.MEDIUM,
            fill: '#FFDCA6',
        });
        if (isHome) {
            this.homeTotalUserCount = textTotalUserCount;
            !this.isMobile && textTotalUserCount.offsetX(textTotalUserCount.width() || 0);
        }
        else {
            this.awayTotalUserCount = textTotalUserCount;
            this.isMobile &&
                textTotalUserCount.offsetX(textTotalUserCount.width() + this.awayIconUser.width() || 0);
        }
        this.group.add(textTotalUserCount);
    }
    drawIconCoinsWonHome() {
        if (this.bgWinningAwayImage &&
            this.iconMedalAwayImage &&
            this.groupIconsWinAway &&
            this.iconGiftAwayImage &&
            this.iconCloverAwayImage &&
            this.iconDiamondBlueAwayImage &&
            this.iconDiamondSilverAwayImage &&
            this.iconCoinRotateAwayImage) {
            this.groupIconsWinAway.add(this.iconDiamondBlueAwayImage, this.iconGiftAwayImage, this.iconCloverAwayImage, this.iconDiamondSilverAwayImage, this.iconCoinRotateAwayImage);
            this.group.add(this.bgWinningAwayImage, this.groupIconsWinAway, this.iconMedalAwayImage);
            this.hideWinningElements();
        }
    }
    drawIconCoinsWonAway() {
        // if (this.iconCoinsWonAway) {
        //   this.group.add(this.iconCoinsWonAway);
        //   this.iconCoinsWonAway.hide(); // Hide the home icon by default
        // }
        if (this.bgWinningHomeImage &&
            this.iconMedalHomeImage &&
            this.groupIconsWinHome &&
            this.iconGiftHomeImage &&
            this.iconCloverHomeImage &&
            this.iconDiamondBlueHomeImage &&
            this.iconDiamondSilverHomeImage &&
            this.iconCoinRotateHomeImage) {
            this.groupIconsWinHome.add(this.iconDiamondBlueHomeImage, this.iconGiftHomeImage, this.iconCloverHomeImage, this.iconDiamondSilverHomeImage, this.iconCoinRotateHomeImage);
            this.group.add(this.bgWinningHomeImage, this.groupIconsWinHome, this.iconMedalHomeImage);
            this.hideWinningElements();
            // this.bgWinningHomeImage.hide(); // Hide the home winning background by default
        }
    }
    drawIconBallThemeSprite() {
        if (this.animationBallTheme) {
            this.group.add(this.animationBallTheme);
        }
    }
    createParticles(count = this.isMobile ? 50 : 200) {
        this.clearParticles();
        // Tính toán khoảng cách giữa các cột hạt để phân bố đều
        const sectionsX = Math.ceil(Math.sqrt(count));
        const sectionWidth = this.stageWidth / sectionsX;
        for (let i = 0; i < count; i++) {
            // Phân bố đều các hạt
            const sectionX = i % sectionsX;
            const baseX = sectionX * sectionWidth;
            const randomOffsetX = Math.random() * sectionWidth;
            const x = baseX + randomOffsetX;
            // Vị trí y ngẫu nhiên ở trên màn hình
            const layerHeight = this.stageHeight * 1.5;
            const y = -layerHeight + Math.random() * layerHeight;
            const speedY = Math.random() * 1 + 0.1;
            const speedX = Math.random() * 0.4 - 0.2;
            const rotationSpeed = Math.random() * 0.7 - 0.35;
            const size = Math.random() * 2 + 0.5;
            const color = this.particleColors[Math.floor(Math.random() * this.particleColors.length)];
            const particle = new Particle(this.stage, x, y, size, color, this.stageHeight, speedY, speedX, rotationSpeed);
            this.particles.push(particle);
            this.group.add(particle.shape);
        }
    }
    // --- End draw methods
    // --- Start all animations start at the same time
    startParticleAnimation() {
        if (this.isParticleAnimating)
            return;
        this.isParticleAnimating = true;
        this.particleAnimation = new SbGameCommon.Animation(() => {
            // Cập nhật vị trí tất cả các hạt
            this.particles.forEach(particle => particle.update());
            return true; // Tiếp tục animation
        });
        this.particleAnimation.start();
    }
    setupAnimationRotate(shape) {
        const period = 50;
        const dxImage = shape.x();
        const dyImage = shape.y();
        const dWidthImage = shape.width();
        const dHeightImage = shape.height();
        shape.position({
            x: dxImage + dWidthImage / 2,
            y: dyImage + dHeightImage / 2,
        });
        shape.offset({
            x: dWidthImage / 2,
            y: dHeightImage / 2,
        });
        return new SbGameCommon.Animation((frame) => {
            const angle = (frame.time * 2 * Math.PI) / period;
            shape.rotation(angle);
        });
    }
    setupAnimationImageScale(shape, minScale = 1.0, maxScale = 1.2) {
        const period = TIMER_SCALE_ANIMATE;
        const dxImage = shape.x();
        const dyImage = shape.y();
        const dWidthImage = shape.width();
        const dHeightImage = shape.height();
        shape.position({
            x: dxImage + dWidthImage / 2,
            y: dyImage + dHeightImage / 2,
        });
        shape.offset({
            x: dWidthImage / 2,
            y: dHeightImage / 2,
        });
        return new SbGameCommon.Animation((frame) => {
            const amplitude = (maxScale - minScale) / 2;
            const midpoint = (maxScale + minScale) / 2;
            const scale = midpoint + amplitude * Math.sin((frame.time * 2 * Math.PI) / period);
            shape.scale({ x: scale, y: scale });
        });
    }
    setupAnimationTextScale(shape) {
        const period = TIMER_SCALE_ANIMATE;
        const dWidthImage = shape.width();
        const dHeightImage = shape.height();
        shape.offset({
            x: dWidthImage / 2,
            y: dHeightImage / 2,
        });
        return new SbGameCommon.Animation((frame) => {
            const minScale = 1.0;
            const maxScale = 1.2;
            const amplitude = (maxScale - minScale) / 2;
            const midpoint = (maxScale + minScale) / 2;
            const scale = midpoint + amplitude * Math.sin((frame.time * 2 * Math.PI) / period);
            shape.scale({ x: scale, y: scale });
        });
    }
    setupAnimationAlignedTextScale(shape) {
        const period = 500;
        let animationRef = null;
        const animate = (frame) => {
            const progress = Math.min(frame.time / period, 1);
            const easedProgress = this.easeOutQuad(progress);
            const minScale = 1.0;
            const maxScale = 1.1;
            let scale;
            if (progress < 0.5) {
                const halfProgress = easedProgress * 2; // 0 to 1 during first half
                scale = minScale + (maxScale - minScale) * this.easeOutQuad(halfProgress);
            }
            else {
                const halfProgress = (easedProgress - 0.5) * 2; // 0 to 1 during second half
                scale = maxScale - (maxScale - minScale) * this.easeInQuad(halfProgress);
            }
            shape.scale({ x: scale, y: scale });
            if (progress >= 0.99) {
                shape.scale({ x: 1, y: 1 }); // Reset to original scale
                if (animationRef) {
                    sleep(0).then(() => {
                        animationRef === null || animationRef === void 0 ? void 0 : animationRef.stop();
                    });
                }
            }
        };
        animationRef = new SbGameCommon.Animation(animate);
        return animationRef;
    }
    easeOutQuad(x) {
        return 1 - (1 - x) * (1 - x);
    }
    easeInQuad(x) {
        return x * x;
    }
    setupAnimationRightAlignedTextScale(shape) {
        const period = TIMER_SCALE_ANIMATE;
        // Store original offset values
        const originalOffsetX = shape.offsetX();
        // Store original width and height (before any scaling)
        const originalWidth = shape.width();
        const originalHeight = shape.height();
        // Calculate position considering any existing offset
        const centerX = shape.x() + (originalOffsetX > 0 ? 0 : originalWidth / 2);
        const centerY = shape.y() + originalHeight / 2;
        // Set the position to the calculated center
        shape.position({
            x: centerX,
            y: centerY,
        });
        // Set the offset based on existing offset
        // If text is already right-aligned (offsetX == width), keep it that way
        shape.offset({
            x: originalWidth / 2,
            y: originalHeight / 2,
        });
        return new SbGameCommon.Animation((frame) => {
            const minScale = 1.0;
            const maxScale = 1.1;
            const amplitude = (maxScale - minScale) / 2;
            const midpoint = (maxScale + minScale) / 2;
            const scale = midpoint + amplitude * Math.sin((frame.time * 2 * Math.PI) / period);
            shape.scale({ x: scale, y: scale });
        });
    }
    createAnimationBallThemeSprite({ animations, dx, dy, dWidth, dHeight, duration, }) {
        const ballSprite = new SbGameCommon.Sprite({
            x: dx,
            y: dy,
            image: this.spriteImage,
            animation: 'rotation',
            animations: {
                rotation: animations,
            },
            easing: SbGameCommon.Easings.EaseInOut,
            frameRate: 8,
            frameIndex: 0,
            duration,
        });
        ballSprite.scale({
            x: dWidth / animations[2],
            y: dHeight / animations[3],
        });
        return ballSprite;
    }
    animateCircleLight() {
        if (this.animationCircleLight) {
            this.animationCircleLight.start();
        }
    }
    animateCircleBlack() {
        if (this.animationCircleBlack) {
            this.animationCircleBlack.start();
        }
    }
    animateCircleTransparent() {
        if (this.animationCircleTransparent) {
            this.animationCircleTransparent.start();
        }
    }
    animateTotalAmountBettingHome() {
        var _a, _b;
        if (this.homeTotalAmountBetting) {
            if (!((_a = this.animationTotalAmountBettingHome) === null || _a === void 0 ? void 0 : _a.isRunning())) {
                this.animationTotalAmountBettingHome = this.setupAnimationAlignedTextScale(this.homeTotalAmountBetting);
                (_b = this.animationTotalAmountBettingHome) === null || _b === void 0 ? void 0 : _b.start();
            }
        }
    }
    animateTotalAmountBettingAway() {
        var _a, _b;
        if (this.awayTotalAmountBetting) {
            if (!((_a = this.animationTotalAmountBettingAway) === null || _a === void 0 ? void 0 : _a.isRunning())) {
                this.animationTotalAmountBettingAway = this.setupAnimationAlignedTextScale(this.awayTotalAmountBetting);
                (_b = this.animationTotalAmountBettingAway) === null || _b === void 0 ? void 0 : _b.start();
            }
        }
    }
    animateBallThemeSprite() {
        if (this.animationBallTheme) {
            this.animationBallTheme.start();
        }
    }
    setupCountdownAnimation(textShape, startValue, endValue = 0, durationInSeconds = 60, onComplete) {
        // Store the original value for calculations
        const originalValue = startValue;
        const totalChange = endValue - originalValue;
        const intervalInMs = 1000; // Update every second
        // Position and styling already set in drawTimerCountdownText()
        // let lastUpdateTime = 0;
        let currentSecond = 0;
        const animation = new SbGameCommon.Animation((frame) => {
            // Calculate elapsed time in seconds
            const elapsedMs = frame.time;
            const currentSecondInAnimation = Math.floor(elapsedMs / intervalInMs);
            // Only update once per second
            if (currentSecondInAnimation > currentSecond) {
                currentSecond = currentSecondInAnimation;
                // Calculate current value
                const secondsPassed = Math.min(currentSecond, durationInSeconds);
                const currentValue = Math.round(startValue + (totalChange / durationInSeconds) * secondsPassed);
                // Update the text
                this.updateFontSizeTimerCountdown(currentValue);
                textShape.text(convertNumberToTimeWithFormat(currentValue));
                textShape.offset({
                    x: Math.floor(textShape.width() / 2),
                    y: Math.floor(textShape.height() / 2),
                });
                // Check if countdown is complete
                if (secondsPassed >= durationInSeconds || currentValue === endValue) {
                    if (onComplete) {
                        onComplete();
                    }
                    // Keep animation running if we want to continue with effects
                    // or return false to stop it
                    return false;
                }
            }
            return true; // Keep animation running
        });
        return animation;
    }
    animateTimerCountdownText() {
        if (!this.timerCountdownText)
            return;
        // Stop previous animation if it exists
        if (this.countdownAnimation) {
            this.countdownAnimation.stop();
            this.countdownAnimation = null;
        }
        // Create new countdown animation
        this.countdownAnimation = this.setupCountdownAnimation(this.timerCountdownText, this.countdownValue, 0, this.countdownValue, // Duration equals the starting value (1 second per count)
        () => {
            this.timeOutCountDown();
        });
        this.countdownAnimation.start();
    }
    // Phương thức tạo hiệu ứng hạt cho đội thắng
    // private createVictoryParticles(teamType: TeamType, count: number) {
    //   // Xóa các hạt cũ
    //   this.clearParticles();
    //   // Xác định khu vực hiển thị hiệu ứng dựa trên đội thắng
    //   let startX, endX;
    //   if (teamType === TeamType.HOME) {
    //     startX = 0;
    //     endX = this.stageWidth / 2;
    //   } else {
    //     startX = this.stageWidth / 2;
    //     endX = this.stageWidth;
    //   }
    //   // Sử dụng màu của đội thắng
    //   const teamColor = teamType === TeamType.HOME ? '#FF0000' : '#0000FF';
    //   const particleColors = [teamColor, '#FFFF00', '#FFFFFF', '#FFD700'];
    //   // Tạo hạt trong khu vực của đội thắng
    //   for (let i = 0; i < count; i++) {
    //     const size = Math.random() * 4 + 1;
    //     const x = startX + Math.random() * (endX - startX);
    //     const y = Math.random() * this.stageHeight - this.stageHeight;
    //     const speedY = Math.random() * 2 + 1;
    //     const speedX = Math.random() * 1 - 0.5;
    //     const rotationSpeed = Math.random() * 3 - 1.5;
    //     // Màu sắc ngẫu nhiên
    //     const color = particleColors[Math.floor(Math.random() * particleColors.length)];
    //     const particle = new Particle(
    //       this.stage,
    //       x,
    //       y,
    //       size,
    //       color,
    //       this.stageHeight,
    //       speedY,
    //       speedX,
    //       rotationSpeed
    //     );
    //     this.particles.push(particle);
    //     this.group.add(particle.shape);
    //   }
    //   // Bắt đầu animation
    //   this.startParticleAnimation();
    // }
    // --- End all animations ---
    // --- Start Public methods to control the banner ---
    timeOutCountDown() {
        if (this.countdownAnimation) {
            this.countdownAnimation.stop();
            this.countdownAnimation = null;
        }
        if (this.timerCountdownText) {
            this.timerCountdownText.remove();
        }
        if (this.circleBlackImage) {
            this.circleBlackImage.remove();
        }
        this.drawIconBallThemeSprite();
        this.animateBallThemeSprite();
    }
    startNewMatch(event) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (this.countdownAnimation) {
            this.countdownAnimation.stop();
        }
        if (this.animationBallTheme) {
            this.animationBallTheme.remove();
        }
        const time = (_a = calculateTimeDifference(new Date(), event[EventItem.StartTime])) !== null && _a !== void 0 ? _a : 0;
        this.countdownValue = time;
        // draw
        this.drawCircleBlack();
        this.drawTimerCountdownText();
        this.hideWinningElements();
        (_b = this.awayIconUser) === null || _b === void 0 ? void 0 : _b.opacity(1);
        (_c = this.homeIconUser) === null || _c === void 0 ? void 0 : _c.opacity(1);
        this.genLogoImage(TeamType.HOME, event === null || event === void 0 ? void 0 : event[EventItem.HomeTeamName]);
        this.genLogoImage(TeamType.AWAY, event === null || event === void 0 ? void 0 : event[EventItem.AwayTeamName]);
        this.drawTextTotalAmountBetting(TeamType.HOME, ((_d = event === null || event === void 0 ? void 0 : event[EventItem.TotalBettingAndTotalUserTeam]) === null || _d === void 0 ? void 0 : _d[TotalBettingAndTotalUserTeamField.HomeTotalBetting]) || 0);
        this.drawTextTotalAmountBetting(TeamType.AWAY, ((_e = event === null || event === void 0 ? void 0 : event[EventItem.TotalBettingAndTotalUserTeam]) === null || _e === void 0 ? void 0 : _e[TotalBettingAndTotalUserTeamField.AwayTotalBetting]) || 0);
        this.drawTextTeamName(TeamType.HOME, event === null || event === void 0 ? void 0 : event[EventItem.HomeTeamName]);
        this.drawTextTeamName(TeamType.AWAY, event === null || event === void 0 ? void 0 : event[EventItem.AwayTeamName]);
        this.drawTotalUserCount(TeamType.HOME, ((_f = event === null || event === void 0 ? void 0 : event[EventItem.TotalBettingAndTotalUserTeam]) === null || _f === void 0 ? void 0 : _f[TotalBettingAndTotalUserTeamField.HomeTotalUser]) || 0);
        this.drawTotalUserCount(TeamType.AWAY, ((_g = event === null || event === void 0 ? void 0 : event[EventItem.TotalBettingAndTotalUserTeam]) === null || _g === void 0 ? void 0 : _g[TotalBettingAndTotalUserTeamField.AwayTotalUser]) || 0);
        // animation
        this.animateTimerCountdownText();
    }
    updateTotalUserBetting(teamType, totalUser) {
        if (!this.homeTotalUserCount || !this.awayTotalUserCount) {
            throw new Error('Total user count elements are not initialized.');
        }
        if (teamType === TeamType.HOME) {
            this.homeTotalUserCount.text(totalUser.toString());
            !this.isMobile && this.homeTotalUserCount.offsetX(this.homeTotalUserCount.width() || 0);
        }
        else {
            this.awayTotalUserCount.text(totalUser.toString());
            this.isMobile &&
                this.awayTotalUserCount.offsetX(this.awayTotalUserCount.width() + this.awayIconUser.width() || 0);
        }
    }
    setAlphaForTeam(teamType, alpha) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (teamType === TeamType.HOME) {
            (_a = this.homeTeamLogo) === null || _a === void 0 ? void 0 : _a.opacity(alpha);
            (_b = this.homeTeamName) === null || _b === void 0 ? void 0 : _b.opacity(alpha);
            (_c = this.homeTotalAmountBetting) === null || _c === void 0 ? void 0 : _c.opacity(alpha);
            (_d = this.homeTotalUserCount) === null || _d === void 0 ? void 0 : _d.opacity(alpha);
            (_e = this.homeIconUser) === null || _e === void 0 ? void 0 : _e.opacity(alpha);
        }
        else {
            (_f = this.awayTeamLogo) === null || _f === void 0 ? void 0 : _f.opacity(alpha);
            (_g = this.awayTeamName) === null || _g === void 0 ? void 0 : _g.opacity(alpha);
            (_h = this.awayTotalAmountBetting) === null || _h === void 0 ? void 0 : _h.opacity(alpha);
            (_j = this.awayTotalUserCount) === null || _j === void 0 ? void 0 : _j.opacity(alpha);
            (_k = this.awayIconUser) === null || _k === void 0 ? void 0 : _k.opacity(alpha);
        }
    }
    hideWinningElements() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        (_a = this.bgWinningHomeImage) === null || _a === void 0 ? void 0 : _a.hide();
        (_b = this.iconMedalHomeImage) === null || _b === void 0 ? void 0 : _b.hide();
        (_c = this.groupIconsWinHome) === null || _c === void 0 ? void 0 : _c.hide();
        (_d = this.tweenIconMedalHome) === null || _d === void 0 ? void 0 : _d.pause();
        (_e = this.tweenGroupIconsWinHome) === null || _e === void 0 ? void 0 : _e.pause();
        (_f = this.bgWinningAwayImage) === null || _f === void 0 ? void 0 : _f.hide();
        (_g = this.iconMedalAwayImage) === null || _g === void 0 ? void 0 : _g.hide();
        (_h = this.groupIconsWinAway) === null || _h === void 0 ? void 0 : _h.hide();
        (_j = this.tweenIconMedalAway) === null || _j === void 0 ? void 0 : _j.pause();
        (_k = this.tweenGroupIconsWinAway) === null || _k === void 0 ? void 0 : _k.pause();
    }
    updateTeamWon(teamWinning) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const teamType = teamWinning === TeamWinningValue.Home ? TeamType.HOME : TeamType.AWAY;
        if (teamType === TeamType.HOME) {
            // this.bgCloseHomeRect?.show();
            (_a = this.bgWinningHomeImage) === null || _a === void 0 ? void 0 : _a.show();
            (_b = this.iconMedalHomeImage) === null || _b === void 0 ? void 0 : _b.show();
            (_c = this.groupIconsWinHome) === null || _c === void 0 ? void 0 : _c.show();
            (_d = this.tweenIconMedalHome) === null || _d === void 0 ? void 0 : _d.play();
            (_e = this.tweenGroupIconsWinHome) === null || _e === void 0 ? void 0 : _e.play();
            this.setAlphaForTeam(TeamType.AWAY, 0.3);
            // Tạo hiệu ứng mưa hạt cho đội thắng cuộc
            // this.createVictoryParticles(TeamType.HOME, 200);
        }
        else {
            // this.bgCloseAwayRect?.show();
            (_f = this.bgWinningAwayImage) === null || _f === void 0 ? void 0 : _f.show();
            (_g = this.iconMedalAwayImage) === null || _g === void 0 ? void 0 : _g.show();
            (_h = this.groupIconsWinAway) === null || _h === void 0 ? void 0 : _h.show();
            (_j = this.tweenIconMedalAway) === null || _j === void 0 ? void 0 : _j.play();
            (_k = this.tweenGroupIconsWinAway) === null || _k === void 0 ? void 0 : _k.play();
            this.setAlphaForTeam(TeamType.HOME, 0.3);
            // Tạo hiệu ứng mưa hạt cho đội thắng cuộc
            // this.createVictoryParticles(TeamType.AWAY, 200);
        }
    }
    updateTotalAmountBetting(teamType, totalAmount, isAnimate = true) {
        if (!this.homeTotalAmountBetting || !this.awayTotalAmountBetting) {
            throw new Error('Total amount betting elements are not initialized.');
        }
        if (teamType === TeamType.HOME) {
            this.homeTotalAmountBetting.text(`$${numberFormat(totalAmount)}`);
            if (isAnimate) {
                this.animateTotalAmountBettingHome();
            }
        }
        else {
            this.awayTotalAmountBetting.text(`${numberFormat(totalAmount)}$`);
            this.awayTotalAmountBetting.offsetX(this.awayTotalAmountBetting.width() || 0);
            if (isAnimate) {
                this.animateTotalAmountBettingAway();
            }
        }
    }
    // Phương thức dừng animation
    stopParticleAnimation() {
        if (this.particleAnimation) {
            this.particleAnimation.stop();
            this.particleAnimation = null;
        }
        this.isParticleAnimating = false;
    }
    // Phương thức xóa tất cả các hạt
    clearParticles() {
        this.stopParticleAnimation();
        this.particles.forEach(particle => particle.remove());
        this.particles = [];
    }
    // --- End Public methods ---
    drawParticles() {
        if (this.particles.length === 0) {
            this.createParticles();
            this.startParticleAnimation();
        }
    }
    renderNotMatch() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        (_a = this.awayTeamLogo) === null || _a === void 0 ? void 0 : _a.remove();
        (_b = this.homeTeamName) === null || _b === void 0 ? void 0 : _b.remove();
        (_c = this.awayTeamName) === null || _c === void 0 ? void 0 : _c.remove();
        (_d = this.homeTotalAmountBetting) === null || _d === void 0 ? void 0 : _d.remove();
        (_e = this.awayTotalAmountBetting) === null || _e === void 0 ? void 0 : _e.remove();
        (_f = this.homeTotalUserCount) === null || _f === void 0 ? void 0 : _f.remove();
        (_g = this.awayTotalUserCount) === null || _g === void 0 ? void 0 : _g.remove();
        // this.iconCoinsWonHome?.hide();
        // this.iconCoinsWonAway?.hide();
        this.hideWinningElements();
        (_h = this.awayIconUser) === null || _h === void 0 ? void 0 : _h.remove();
        (_j = this.homeIconUser) === null || _j === void 0 ? void 0 : _j.remove();
        (_k = this.homeBoxTotalAmountBetting) === null || _k === void 0 ? void 0 : _k.remove();
        (_l = this.awayBoxTotalAmountBetting) === null || _l === void 0 ? void 0 : _l.remove();
        (_m = this.animationCircleLight) === null || _m === void 0 ? void 0 : _m.stop();
        (_o = this.animationBallTheme) === null || _o === void 0 ? void 0 : _o.stop();
        this.drawBackground();
        this.drawIconCoinsWonHome();
        this.drawIconCoinsWonAway();
        this.drawCircleLight();
        this.drawBackgroundZIndex1();
        this.drawCircleTransparent();
        this.drawInviteStart();
        this.drawCircleTransparent();
        this.drawParticles();
        this.genLogoImage(TeamType.HOME, '');
        this.genLogoImage(TeamType.AWAY, '');
        this.drawIconBallThemeSprite();
    }
    renderFirstMatch(event) {
        var _a, _b, _c;
        (_a = this.homeTeamLogo) === null || _a === void 0 ? void 0 : _a.remove();
        (_b = this.awayTeamLogo) === null || _b === void 0 ? void 0 : _b.remove();
        (_c = this.animationBallTheme) === null || _c === void 0 ? void 0 : _c.remove();
        this.render(event);
    }
    render(event) {
        var _a, _b, _c, _d, _e;
        const isLive = !!event[EventItem.IsLive];
        this.countdownValue = (_a = calculateTimeDifference(new Date(), event[EventItem.StartTime])) !== null && _a !== void 0 ? _a : 0;
        this.drawBackground();
        this.drawIconCoinsWonHome();
        this.drawIconCoinsWonAway();
        this.drawCircleLight();
        this.drawBackgroundZIndex1();
        this.drawInviteStart();
        this.drawCircleTransparent();
        this.drawParticles();
        if (!isLive) {
            this.drawCircleBlack();
            this.drawTimerCountdownText();
        }
        this.genLogoImage(TeamType.HOME, event === null || event === void 0 ? void 0 : event[EventItem.HomeTeamName]);
        this.genLogoImage(TeamType.AWAY, event === null || event === void 0 ? void 0 : event[EventItem.AwayTeamName]);
        this.drawTextTeamName(TeamType.HOME, event === null || event === void 0 ? void 0 : event[EventItem.HomeTeamName]);
        this.drawTextTeamName(TeamType.AWAY, event === null || event === void 0 ? void 0 : event[EventItem.AwayTeamName]);
        this.drawBoxTotalAmountBetting(TeamType.HOME);
        this.drawTextTotalAmountBetting(TeamType.HOME, ((_b = event === null || event === void 0 ? void 0 : event[EventItem.TotalBettingAndTotalUserTeam]) === null || _b === void 0 ? void 0 : _b[TotalBettingAndTotalUserTeamField.HomeTotalBetting]) || 0);
        this.drawBoxTotalAmountBetting(TeamType.AWAY);
        this.drawTextTotalAmountBetting(TeamType.AWAY, ((_c = event === null || event === void 0 ? void 0 : event[EventItem.TotalBettingAndTotalUserTeam]) === null || _c === void 0 ? void 0 : _c[TotalBettingAndTotalUserTeamField.AwayTotalBetting]) || 0);
        this.drawUserIconTeam(TeamType.HOME);
        this.drawUserIconTeam(TeamType.AWAY);
        this.drawTotalUserCount(TeamType.HOME, ((_d = event === null || event === void 0 ? void 0 : event[EventItem.TotalBettingAndTotalUserTeam]) === null || _d === void 0 ? void 0 : _d[TotalBettingAndTotalUserTeamField.HomeTotalUser]) || 0);
        this.drawTotalUserCount(TeamType.AWAY, ((_e = event === null || event === void 0 ? void 0 : event[EventItem.TotalBettingAndTotalUserTeam]) === null || _e === void 0 ? void 0 : _e[TotalBettingAndTotalUserTeamField.AwayTotalUser]) || 0);
        // if (this.bgCloseAwayRect && this.bgCloseHomeRect) {
        //   this.layer.add(this.bgCloseAwayRect, this.bgCloseHomeRect);
        // }
        if (this.iconMedalAwayImage && !this.tweenIconMedalAway) {
            this.tweenIconMedalAway = new SbGameCommon.Tween({
                node: this.iconMedalAwayImage,
                duration: 0.5,
                rotation: Math.PI / 2,
                yoyo: true,
                easing: SbGameCommon.Easings.Linear,
            });
        }
        if (this.iconMedalHomeImage && !this.tweenIconMedalHome) {
            this.tweenIconMedalHome = new SbGameCommon.Tween({
                node: this.iconMedalHomeImage,
                duration: 0.5,
                rotation: Math.PI / 2,
                yoyo: true,
                easing: SbGameCommon.Easings.Linear,
            });
        }
        if (!this.tweenGroupIconsWinAway) {
            this.tweenGroupIconsWinAway = new SbGameCommon.Tween({
                node: this.groupIconsWinAway,
                duration: 0.5,
                rotation: Math.PI / 2,
                opacity: 0.5,
                yoyo: true,
                easing: SbGameCommon.Easings.Linear,
            });
        }
        if (this.iconMedalHomeImage && !this.tweenIconMedalHome) {
            this.tweenIconMedalHome = new SbGameCommon.Tween({
                node: this.iconMedalHomeImage,
                duration: 0.5,
                rotation: Math.PI / 2,
                yoyo: true,
                easing: SbGameCommon.Easings.Linear,
            });
        }
        if (!this.tweenGroupIconsWinHome) {
            this.tweenGroupIconsWinHome = new SbGameCommon.Tween({
                node: this.groupIconsWinHome,
                duration: 0.5,
                rotation: Math.PI / 2,
                opacity: 0.5,
                yoyo: true,
                easing: SbGameCommon.Easings.Linear,
            });
        }
        if (isLive) {
            this.drawIconBallThemeSprite();
            this.animateBallThemeSprite();
            if (!!(event === null || event === void 0 ? void 0 : event[EventItem.ResultCode])) {
                this.updateTeamWon(event[EventItem.TeamWinning]);
            }
        }
        else {
            this.animateTimerCountdownText();
        }
        this.animateCircleLight();
        // Animate all elements
        // this.animateCircleBlack();
        // this.animateCircleTransparent();
        // this.animateTimerCountdownText();
        // this.animateTotalAmountBettingHome();
        // this.animateTotalAmountBettingAway();
        // this.animateBallThemeSprite();
    }
}
export default BannerVoltaModel;
